<template>
	<div class="Login_in rel flex" ref="caogaoxiang">
		<el-image fit="cover" class="w50" :src="require('@/assets/pc/login/register_bj.png')" alt="" style="" />
		<div class="bj-0 juzhong w50 rel flex j-center a-right">
			<el-image fit="contain" class="logot abs cur_pointer" @click="Shouye" :src="require('@/assets/pc/login/logo.png')" alt=""
				style="top: .67rem;left: 1rem;" />
			<div class="w100 h60  flex column a-center">
				<div class="f-32 montserRegular mb-40" v-if="gudingziduan">{{gudingziduan.Logins.LogInWithYourAccount?gudingziduan.Logins.LogInWithYourAccount:'Log In With Your Account'}}</div>
				<div class="annniu f-18 flex a-center ys-0 j-center cur_pointer" @click="daikaiUrl">
					<i class="iconfont f-30 icon-Frame mr-28"></i>
					GoodWe SEMS
				</div>
				<div class="f-18 flex a-center j-center mt-50" style="color: #666666;">
					{{gudingziduan.Logins.Donthaveanaccountyet}}
					<i @click="tiaoye(1)" class="ml-8 cur_pointer" style="color: #DF353C;text-decoration: underline;">{{gudingziduan.Logins.SignupasEndUser}}</i>
					<i class="ml-8 cur_pointer" style="color: #333;">|</i>
					<i @click="tiaoye(2)" class="ml-8 cur_pointer" style="color: #DF353C;text-decoration: underline;">{{gudingziduan.Logins.SignupasInstaller}}</i>
					  
					<!-- <i @click="tiaoye()" class="ml-8 cur_pointer" style="color: #DF353C;text-decoration: underline;">Sign up here.</i> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import Header from '@/zujian/pc/Header.vue'
let that;
import { loginIn, getLogin } from '@/api/login.js';
export default {
	data() {
		return {
			code: null,
			gradients: [
				['#FDEB71', '#F8D800'],
				['#ABDCFF', '#0396FF'],
				['#FEB692', '#EA5455'],
				['#CE9FFC', '#7367F0'],
				['#90F7EC', '#32CBCB'],
				['#FFF6B7', '#F6416C'],
				['#81FBB8', '#28C76F'],
				['#E2B0FF', '#9F44D3'],
				['#F97794', '#623AA2'],
				['#FCCF31', '#F55555'],
				['#F761A1', '#8C1BAB'],
				['#43CBFF', '#9708CC'],
				['#5EFCE8', '#736EFE'],
				['#FAD7A1', '#E96D71'],
				['#FFD26F', '#3677FF'],
				['#A0FE65', '#FA016D'],
				['#FFDB01', '#0E197D'],
				['#FEC163', '#DE4313'],
				['#92FFC0', '#002661'],
				['#EEAD92', '#6018DC'],
				['#F6CEEC', '#D939CD'],
				['#52E5E7', '#130CB7'],
				['#F1CA74', '#A64DB6'],
				['#E8D07A', '#5312D6'],
				['#EECE13', '#B210FF'],
				['#79F1A4', '#0E5CAD'],
				['#FDD819', '#E80505'],
				['#FFF3B0', '#CA26FF'],
				['#FFF5C3', '#9452A5'],
				['#F05F57', '#360940'],
				['#2AFADF', '#4C83FF'],
				['#FFF886', '#F072B6'],
				['#97ABFF', '#123597'],
				['#F5CBFF', '#C346C2'],
				['#FFF720', '#3CD500'],
				['#FF6FD8', '#3813C2'],
				['#EE9AE5', '#5961F9'],
				['#FFD3A5', '#FD6585'],
				['#C2FFD8', '#465EFB'],
				['#FD6585', '#0D25B9'],
				['#FD6E6A', '#FFC600'],
				['#65FDF0', '#1D6FA3'],
				['#6B73FF', '#000DFF'],
				['#FF7AF5', '#513162'],
				['#F0FF00', '#58CFFB'],
				['#FFE985', '#FA742B'],
				['#FFA6B7', '#1E2AD2'],
				['#FFAA85', '#B3315F'],
				['#72EDF2', '#5151E5'],
				['#FF9D6C', '#BB4E75'],
				['#F6D242', '#FF52E5'],
				['#69FF97', '#00E4FF'],
				['#3B2667', '#BC78EC'],
				['#70F570', '#49C628'],
				['#3C8CE7', '#00EAFF'],
				['#FAB2FF', '#1904E5'],
				['#81FFEF', '#F067B4'],
				['#FFA8A8', '#FCFF00'],
				['#FFCF71', '#2376DD'],
				['#FF96F9', '#C32BAC'],
				// 这里可以添加更多的颜色组合  
			],
			yansezu: [],
			gudingziduan:{Logins:{}},
			fromPath:''
		}
	},
	mounted() {
		that = this;
		if(this.$qu('yuyancodes')!=[] && this.$qu('yuyancodes')!=''){
			this.yuyancode=this.$qu('yuyancodes')
			this.$store.commit('Gaiyuyan',this.$qu('yuyancodes'));
		}else{
			this.yuyancode=this.$store.state.yuyan
			this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
		}
		that.gudingziduan=that.$store.state.cunyuanyan
		console.log(this.$qu('loginFromPath'))
		that.code = that.$route.query.code || null;
		if (!that.code) {
		  // 记录来源页面：router的history中上一个页面的fullPath（完整路由地址，包含参数）
		  that.fromPath ='/'; // 兜底跳转到首页
		  // that.$cun('loginFromPath', that.fromPath); // 用你的缓存方法存起来
		}else if(this.code) {
			const loading = this.$loading({
			target: this.$refs.caogaoxiang,
			  lock: true,
			  text: 'Loading',
			  spinner: 'el-icon-loading',
			  background: 'rgba(0, 0, 0, 0.2)',
			  customClass: 'custom-loading'
			});
		
			loginIn({code: this.code}).then(shu => {
				if(shu.code == 200) {
					loading.close();
					this.$cun('kouling',shu.data.token)
					if(shu.data.nickname){
						this.$cun('yonghuming',shu.data.nickname)
					}else{
						
						this.$cun('yonghuming',shu.data.account)
					}
					// this.$cun('yonghuming',shu.data.nickname)
					this.$cun('guserid',shu.data.id)
					// this.$xiaoxi('Login successful')
					if(shu.data.id){
						let gradient =this.$qu('uColor2_'+shu.data.id);
						if (gradient.length<=0) {
							const index = Math.floor(Math.random() * this.gradients.length);
							gradient = this.gradients[index]; 
							let yansess=gradient[0]+','+gradient[1]
							this.$cun('uColor2_'+shu.data.id,yansess);
						}
					}
					this.$message({
					  showClose: true,
					  message:'Login successfully',
					  type: 'success',
					  offset:'350'
					})
					setTimeout(()=>{
						// this.$router.go(-3);
						if(this.$qu('loginFromPath')){
							that.fromPath = this.$qu('loginFromPath'); // 取缓存的来源地址，兜底首页
						}else{
							that.fromPath ='/'
						}
						this.$router.push(that.fromPath); // 用push跳转，而非go(-3)
						console.log()
						this.$cun('loginFromPath', ''); // 清空缓存，避免后续重复使用
					},500)
				}else{
					// this.$route.query.code=null
					this.$router.replace({ query: { code: null } }); // 正确清空路由query的方式
					this.$cun('kouling',0)
				}
			})
			// console.log('1111111')
		}
		
	},
	methods: {
		Shouye() {
			this.$router.push('/')
		},
		daikaiUrl() {
		// 	if(this.code) {
		// 		loginIn({code: this.code}).then(shu => {
		// 			if(shu.code == 200) {
		// 				this.$cun('kouling',shu.data.token)
		// 				this.$cun('yonghuming',shu.data.nickname)
		// 				this.$cun('guserid',shu.data.id)
		// 				// this.$xiaoxi('Login successful')
		// 				this.$message({
		// 				  showClose: true,
		// 				  message:'Login successfully',
		// 				  type: 'success',
		// 				  offset:'350'
		// 				})
		// 				setTimeout(()=>{
		// 					this.$dakai('/')
		// 				},500)
		// 			}
		// 		})
		// 	}else {
				getLogin().then(shu => {
					if(shu.code == 200) {
						 window.location.href=shu.data
						// window.open(shu.data, '_blank');
					}
				})
			// }
			
			// window.open('https://www.semsportal.com/Home/InstallerOpenRegistration', '_blank');
		},
		tiaoye(e){
			if(e==1){
				window.open('https://www.semsportal.com/home/register')
			}else{
				window.open('https://hk.semsportal.com/Home/InstallerOpenRegistration')
				
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.Login_in {
	::v-deep.custom-loading .el-loading-text,::v-deep.custom-loading .el-icon-loading {
	  color: #ff0000; /* 设置文字颜色为红色，你可以根据需要修改 */
	}
	background: url('../../../assets/pc/login.png') no-repeat;
	background-size: cover;
	height: 100vh;

	.juzhong {
		.logot {
			max-width: 3rem;
		}
	}

	::v-deep .el-image {
		display: inline-block;
		overflow: hidden;
	}

	.annniu {
		width: 4.99rem;
		height: .71rem;
		background: linear-gradient(89deg, #ff7658 0%, #e70214 100%);
		border-radius: 36px;
	}

	::v-deep.regis {
		input {
			border: none;
			background: transparent;
			height: auto;
			line-height: initial;
			padding: 0;
			font-size: .18rem;
		}

		.shuru .el-input__inner {
			border-radius: 10px;
			border: 1px solid #949494;
			height: .58rem;
		}


	}
}


// ==========================================================================================================================================================================
// 响应式
@media screen and (max-width: 767px) {
	body {background-color: #fff !important;}


	.Login_in {display: block; background: #fff;}
	.Login_in > .el-image {width: 100%; max-height: 30vh;}
	.Login_in .juzhong {width: 100%; display: block;}

	.Login_in .juzhong .logot {width: 100%; display: flex; position: relative; top: 0 !important; left: 0 !important; text-align: center;margin: .5rem auto; }
	.juzhong .h60 {height: auto;}
}


</style>